import type { Experiment } from '@/types/aggregation/home';
import { GameVariant } from '@/types/reward-machine';
import { AMPLITUDE_EXPERIMENTS, getExperimentValue } from '@/utils/experiments';

export const getRewardMachineGameVariant = (experiments: Experiment): GameVariant | undefined =>
    getExperimentValue(experiments, AMPLITUDE_EXPERIMENTS.FANDUEL_REWARD_MACHINE) ===
    AMPLITUDE_EXPERIMENTS.FANDUEL_REWARD_MACHINE
        ? GameVariant.FANDUEL
        : undefined;
